module.exports = __webpack_public_path__ + "static/room03-c66d7900b2ea96e6f4416c95759cfa2c.jpg";